import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import * as _ from 'lodash';

import { DatePickerField, InputField } from 'Common/SemanticWrapper';
import { SELECTION_LETTERS_FORM_NAME, InputMode } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { SelectionLettersFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { YesNoOptions, normalizePhone } from 'Common/FormHelper';
import { UseStudentAddressButtonGroup } from 'Common/Components/UseStudentAddressButtonGroup/UseStudentAddressButtonGroup';

class SelectionLettersFormContainer extends Component {
  printOptions = [
    { label: 'Unprinted', value: true },
    { label: 'Printed', value: false },
  ];

  render() {
    const { formValues, loading, writing } = this.props;
    return (
      <Fragment>
        <Form name={SELECTION_LETTERS_FORM_NAME}>
          <TitledCard title={'Letter Settings'}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    label={'Date of Letter'}
                    name={Fields.LetterDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={moment()}
                    disabled={loading}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    label={'Date by which information must be received'}
                    name={Fields.ReceivedDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={moment()}
                    disabled={loading}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Field
                    label={'Date by which verification will be completed'}
                    name={Fields.CompletedDate}
                    component={DatePickerField}
                    type="text"
                    openToDate={moment()}
                    disabled={loading}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    name={Fields.StaffName}
                    component={InputField}
                    label={
                      'Child Nutrition Staff Person To Be Contacted For More Information'
                    }
                    disabled={loading}
                    maxLength={75}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    name={Fields.StaffPhone}
                    component={InputField}
                    label={"Child Nutrition Staff Person's Phone Number"}
                    disabled={loading}
                    maxLength={14}
                    mode={InputMode.Integer}
                    normalize={normalizePhone}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          <TitledCard title={'Print Options'}>
            <Grid>
              <Grid.Row style={{ marginBottom: '10px' }}>
                <Grid.Column width={3} className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Show Site Name'}
                    options={YesNoOptions}
                    formName={SELECTION_LETTERS_FORM_NAME}
                    value={formValues[Fields.ShowSiteName]}
                    fieldName={Fields.ShowSiteName}
                    disabled={loading}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <UseStudentAddressButtonGroup
                    formName={SELECTION_LETTERS_FORM_NAME}
                    fieldName={Fields.UseStudentAddress}
                    name={Fields.UseStudentAddress}
                    disabled={loading}
                    label={'Use Student Address If Available'}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4} className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Print which letters?'}
                    options={this.printOptions}
                    formName={SELECTION_LETTERS_FORM_NAME}
                    value={formValues[Fields.PrintUnprinted]}
                    fieldName={Fields.PrintUnprinted}
                    disabled={loading}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <Field
                    name={Fields.UnprintedCount}
                    component={InputField}
                    label={'Unprinted'}
                    readOnly={!writing}
                    loading={writing}
                    disabled={writing}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <Field
                    name={Fields.PrintedCount}
                    component={InputField}
                    label={'Printed'}
                    readOnly={!writing}
                    loading={writing}
                    disabled={writing}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  var errors = [];

  if (
    values[Fields.StaffPhone] &&
    _.trim(values[Fields.StaffPhone]).length < 14
  ) {
    errors[Fields.StaffPhone] = 'Enter a valid phone number.';
  }
  if (_.isNil(values[Fields.LetterDate])) {
    errors[Fields.LetterDate] = 'Letter date is required.';
  }
  if (_.isNil(values[Fields.ReceivedDate])) {
    errors[Fields.ReceivedDate] = 'Received date is required.';
  }
  if (_.isNil(values[Fields.CompletedDate])) {
    errors[Fields.CompletedDate] = 'Completion date is required.';
  }
  if (_.isNil(values[Fields.StaffName])) {
    errors[Fields.StaffName] = 'Staff person name is required.';
  }
  if (_.isNil(values[Fields.StaffPhone])) {
    errors[Fields.StaffPhone] = 'Staff person phone is required.';
  }

  return errors;
};

const SelectionLettersForm = reduxForm({
  form: SELECTION_LETTERS_FORM_NAME,
  validate,
  touchOnChange: false,
  enableReinitialize: true,
})(withRouter(SelectionLettersFormContainer));

export { SelectionLettersForm };



// WEBPACK FOOTER //
// ./src/pages/selectionletters/components/SelectionLettersForm.js